export { unstable_batchedUpdates } from 'react-dom'
